export const NotificationSettingsApiPath = {
  GET_NOTIFICATION_SETTINGS: '/api/sites/{site_id}/notification-settings', // GET Get Notification Settings
  UPDATE_NOTIFICATION_SETTINGS: '/api/sites/{site_id}/notification-settings' // PUT Update Notification Settings
}

export type NotificationSettingsApiPath =
  (typeof NotificationSettingsApiPath)[keyof typeof NotificationSettingsApiPath]

export interface GetNotificationSettingsVars {
  site_id: number
}

export interface UpdateNotificationSettingsVars {
  site_id: number
  settings: NotificationSetting[]
}

export interface NotificationSetting {
  operator_id: number
  name: string
  email: string
  enabled: boolean
}

export type GetNotificationSettingsResponse = NotificationSetting[]

export interface UpdateNotificationSettingsResponse {
  ok: boolean
}
